import styled from "styled-components";
import TopBar from "../../../Component/UI/TopBar";
import { useRef, useState } from "react";
import Step1 from "./Component/Step1";
import Step2 from "./Component/Step2";
import TermsAgreement from "./Component/Step3";
import CompleteModal from "./Modal/CompleteModal";
import axios from "axios";
import url from "../../../Component/server";
import { GTM_EVENTS, pushGtmEvent } from "../../../Component/analytics/gtm";

const AdminSignUp = () => {
  const [step, setStep] = useState(1);
  const [submitting, setSubmitting] = useState(false);
  const formContentRef = useRef<HTMLElement>(null);
  const nextStep = () => {
    handleStep(step + 1);
  };
  const backStep = () => {
    handleStep(step - 1);
  };
  const handleStep = (data: number) => {
    if (data === 2 && !validateCredentials()) return;
    setStep(data);
    if (formContentRef.current) formContentRef.current.scrollTop = 0;
  };

  // Step1
  // 대표자명
  const [name, setName] = useState("");
  const handleName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setName(input);
  };

  // 연락처
  const [phoneNum, setPhoneNum] = useState("");
  const handlePhoneNum = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setPhoneNum(input);
  };

  // 이메일
  const [email, setEmail] = useState("");
  const [domain, setDomain] = useState("");
  const [selectDomain, setSelectDomain] = useState("");

  const handleEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setEmail(input);
  };
  const handleDomain = (e: React.ChangeEvent<HTMLInputElement> | string) => {
    typeof e === "string" ? setDomain(e) : setDomain(e.target.value);
  };
  const handleSelectDomain = (data: string) => {
    setSelectDomain(data);
  };

  // 셀러 로그인 계정
  const [userid, setUserid] = useState("");
  const [userpw, setUserpw] = useState("");
  const [userpwConfirm, setUserpwConfirm] = useState("");

  // Step2
  // 사업자명
  const [BUSName, setBUSName] = useState("");
  const handleBUSName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setBUSName(input);
  };

  // 사업자 주소
  const [BUSPostCode, setBUSPostCode] = useState("");
  const [BUSFirAddr, setBUSFirAddr] = useState("");
  const [BUSSecAddr, setBUSSecAddr] = useState("");

  const handlePostCode = (data: string) => {
    setBUSPostCode(data);
  };
  const handleFirAddr = (data: string) => {
    setBUSFirAddr(data);
  };
  const handleSecAddr = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setBUSSecAddr(input);
  };

  // 사업자등록증
  const [BUSImage, setBUSImage] = useState<string[]>([]);
  const uploadBUSImage = (data: string) => {
    setBUSImage((prev) => [...prev, data]);
  };
  const delBUSImage = (data: string, index: number) => {
    setBUSImage((prev) => prev.filter((_, i) => i !== index));
  };

  // 기본 정보: 스토어명
  const [storeName, setStoreName] = useState("");
  const handleStoreName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setStoreName(input);
    setStoreNameCheck(false);
  };
  const [storeNameCheck, setStoreNameCheck] = useState(false);

  // 약관
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);

  const handleCheck1 = () => {
    setCheck1(!check1);
  };
  const handleCheck2 = () => {
    setCheck2(!check2);
  };

  // 완료 모달
  const [visible, setVisible] = useState(false);
  const handleModal = () => {
    setVisible(!visible);
  };

  const validateCredentials = () => {
    if (!/^[A-Za-z0-9][A-Za-z0-9_.-]{3,19}$/.test(userid)) {
      alert("아이디는 영문 또는 숫자로 시작하고, 영문·숫자·_ . - 조합으로 4~20자 입력해주세요.");
      return false;
    } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[!-~]{5,72}$/.test(userpw)) {
      alert("비밀번호는 대문자, 소문자, 숫자, 특수문자를 포함한 5자 이상으로 입력해주세요.");
      return false;
    } else if (userpw !== userpwConfirm) {
      alert("비밀번호 확인이 일치하지 않습니다.");
      return false;
    }
    return true;
  };

  // 입점 신청
  const create_store = async () => {
    if (submitting) return;
    // 필수 값 확인
    if (
      !userid ||
      !userpw ||
      !userpwConfirm ||
      !storeName ||
      !name ||
      !phoneNum ||
      !email ||
      !BUSName ||
      !BUSPostCode ||
      !BUSFirAddr ||
      !BUSSecAddr ||
      !check1 ||
      !check2 ||
      BUSImage.length === 0
    ) {
      alert("모든 필수 정보를 입력해주세요.");
      return;
    } else if (!validateCredentials()) {
      return;
    } else if (!storeNameCheck) {
      alert("스토어명 중복확인을 해주세요.");
      return;
    }

    // API 호출
    setSubmitting(true);
    try {
      const res = await axios.post(
        url.Communication_url.create_store,
        {
          userid: userid.trim(),
          userpw,
          store_name: storeName,
          rep_name: name,
          store_phone: phoneNum,
          store_email: email + "@" + domain,
          com_name: BUSName,
          addr_num: BUSPostCode,
          addr_basic: BUSFirAddr,
          addr_detail: BUSSecAddr,
          profile_img: "",
          terms_agree: "y",
          privacy_agree: "y",
          license: BUSImage[0],
        },
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );
      if (res.data === "성공") {
        pushGtmEvent(GTM_EVENTS.join, userid.trim(), userid.trim());
        handleModal();
      }
    } catch (error: any) {
      console.log(error);
      const msg = error.response?.data?.message || "입점 신청 처리 중 오류가 발생했습니다. 다시 시도해 주세요.";
      alert(Array.isArray(msg) ? msg.join("\n") : msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <SignupPage>
      <SignupCard>
        <TopBar title="입점 신청" color="white" />
        <FormContent ref={formContentRef}>
          <StepNavigation aria-label="입점 신청 단계">
            <StepBox
              type="button"
              aria-current={step === 1 ? "step" : undefined}
              $select={step === 1}
              onClick={() => {
                handleStep(1);
              }}
            >
              1. 기본 정보
            </StepBox>
            <StepBox
              type="button"
              aria-current={step === 2 ? "step" : undefined}
              $select={step === 2}
              onClick={() => {
                handleStep(2);
              }}
            >
              2. 사업자 정보
            </StepBox>
          </StepNavigation>
          {step === 1 ? (
            <Step1
              storeName={storeName}
              handleStoreName={handleStoreName}
              setStoreNameCheck={setStoreNameCheck}
              name={name}
              handleName={handleName}
              phoneNum={phoneNum}
              handlePhoneNum={handlePhoneNum}
              email={email}
              handleEmail={handleEmail}
              domain={domain}
              handleDomain={handleDomain}
              selectDomain={selectDomain}
              handleSelectDomain={handleSelectDomain}
              userid={userid}
              setUserid={setUserid}
              userpw={userpw}
              setUserpw={setUserpw}
              userpwConfirm={userpwConfirm}
              setUserpwConfirm={setUserpwConfirm}
            />
          ) : (
            <>
              <Step2
                BUSName={BUSName}
                handleBUSName={handleBUSName}
                BUSPostCode={BUSPostCode}
                BUSFirAddr={BUSFirAddr}
                BUSSecAddr={BUSSecAddr}
                setBUSPostCode={setBUSPostCode}
                setBUSFirAddr={setBUSFirAddr}
                handleSecAddr={handleSecAddr}
                BUSImage={BUSImage}
                uploadBUSImage={uploadBUSImage}
                delBUSImage={delBUSImage}
              />
              <TermsSection aria-labelledby="seller-terms-title">
                <TermsTitle id="seller-terms-title">약관 동의</TermsTitle>
                <TermsAgreement
                  check1={check1}
                  check2={check2}
                  handleCheck1={handleCheck1}
                  handleCheck2={handleCheck2}
                />
              </TermsSection>
            </>
          )}
        </FormContent>
        <Actions aria-label="가입 단계 이동">
          <BackBtn
            as="button"
            type="button"
            disabled={submitting}
            style={{ display: step === 1 ? "none" : "flex" }}
            onClick={backStep}
          >
            이전
          </BackBtn>
          <NextBtn
            as="button"
            type="button"
            disabled={submitting}
            style={{ display: step === 2 ? "none" : "flex" }}
            onClick={nextStep}
          >
            다음
          </NextBtn>
          <NextBtn
            as="button"
            type="button"
            disabled={submitting}
            style={{ display: step === 2 ? "flex" : "none" }}
            onClick={create_store}
          >
            {submitting ? "신청 중" : "신청하기"}
          </NextBtn>
        </Actions>
      </SignupCard>
      <CompleteModal visible={visible} handleModal={handleModal} />
    </SignupPage>
  );
};

export default AdminSignUp;

const SignupPage = styled.div`
  height: 100dvh;
  width: 100%;
  overflow: hidden;
  background: var(--color-bg-surface);
  color: var(--color-text-primary);
  font-family: var(--font-family-base);
`;

const SignupCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  height: 100%;
  margin: 0 auto;
  > header { flex-shrink: 0; }
`;

const FormContent = styled.main`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  padding: var(--space-6) var(--space-4);
  scrollbar-width: thin;
  &::-webkit-scrollbar { width: var(--space-1); }
  &::-webkit-scrollbar-thumb { background: var(--color-border-strong); border-radius: var(--radius-pill); }
  font-family: var(--font-family-base);
  font-size: var(--text-body);
  line-height: var(--leading-body);
`;

const StepNavigation = styled.nav`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-2);
  margin-bottom: var(--space-8);
`;

const StepBox = styled.button<{ $select: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: var(--control-lg);
  padding: var(--space-2);
  border: 1px solid;
  border-radius: var(--radius-md);
  border-color: ${props => props.$select ? "var(--color-brand)" : "var(--color-border-default)"};
  background: ${props => props.$select ? "var(--color-brand-subtle)" : "var(--color-bg-surface)"};
  color: ${props => props.$select ? "var(--color-text-primary)" : "var(--color-text-secondary)"};
  &&& { font-size: var(--text-caption); line-height: var(--leading-caption); }
  font-weight: var(--font-weight-medium);
  text-align: center;
  word-break: keep-all;
  cursor: pointer;
`;

const TermsSection = styled.section`
  display: grid;
  gap: var(--space-5);
  margin-top: var(--space-8);
  padding-top: var(--space-8);
  border-top: 1px solid var(--color-border-default);
`;

const TermsTitle = styled.h2`
  margin: 0;
  font-size: var(--text-h3);
  line-height: var(--leading-h3);
  font-weight: var(--font-weight-semibold);
`;

const Actions = styled.footer`
  display: flex;
  align-items: center;
  gap: var(--space-4);
  flex-shrink: 0;
  padding: var(--space-4);
  padding-bottom: calc(var(--space-4) + env(safe-area-inset-bottom));
  border-top: 1px solid var(--color-border-default);
  background: var(--color-bg-surface);
`;

const Btn = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--control-xl);
  border: 0;
  border-radius: var(--radius-md);
  &&& { font-size: var(--text-body-lg); }
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  &:disabled {
    background: var(--color-bg-muted);
    color: var(--color-text-disabled);
    cursor: not-allowed;
  }
`;

const NextBtn = styled(Btn)`
  background: var(--gradient-brand);
  color: var(--color-text-on-brand);
  &:hover:not(:disabled) { background: var(--gradient-brand-hover); }
`;

const BackBtn = styled(Btn)`
  background: var(--color-bg-muted);
  color: var(--color-text-primary);
`;
